import { c as _c } from "react/compiler-runtime";
import { useSortingQueryParam } from "@hooks/table-sort/use-sorting-query-param";
import { useEffect, useState } from "react";
/** Hook to manage the subjects sortBy query parameter */
export function useSubjectsSortByQuery(options) {
  const $ = _c(10);
  let t0;
  if ($[0] !== options.defaultSort || $[1] !== options.isValidSort) {
    t0 = {
      defaultSort: options.defaultSort,
      isValidSort: options.isValidSort
    };
    $[0] = options.defaultSort;
    $[1] = options.isValidSort;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const {
    sortBy: newSortBy,
    setSortBy: setNewSortBy
  } = useSortingQueryParam(t0);
  const [cachedSortBy, setCachedSortBy] = useState(newSortBy);
  let t1;
  let t2;
  if ($[3] !== cachedSortBy || $[4] !== newSortBy) {
    t1 = () => {
      if (newSortBy !== cachedSortBy) {
        setCachedSortBy(newSortBy);
      }
    };
    t2 = [newSortBy, cachedSortBy];
    $[3] = cachedSortBy;
    $[4] = newSortBy;
    $[5] = t1;
    $[6] = t2;
  } else {
    t1 = $[5];
    t2 = $[6];
  }
  useEffect(t1, t2);
  let t3;
  if ($[7] !== cachedSortBy || $[8] !== setNewSortBy) {
    t3 = {
      sortBy: cachedSortBy,
      setSortBy: setNewSortBy
    };
    $[7] = cachedSortBy;
    $[8] = setNewSortBy;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}